import { ViewListIcon } from "@heroicons/react/outline";
import type { ComponentProps } from "react";

import { InputVariablesPopoverContent } from "../InputVariablesPopoverContent";

import { Button } from "@/components/ui/button";
import { Popover, PopoverTrigger } from "@/components/ui/popover";
import type { RequestInputVariables } from "@/queries/requests/useRequestLogInputVariables";

interface InputVariablesPopoverProps {
  variables: RequestInputVariables;
  requestId?: string | number | null;
  disabled?: boolean;
  onTriggerClick?: ComponentProps<typeof Button>["onClick"];
}

const InputVariablesPopover = ({
  variables,
  requestId,
  disabled = false,
  onTriggerClick,
}: InputVariablesPopoverProps) => (
  <Popover>
    <PopoverTrigger asChild>
      <Button size="sm" variant="ghost" disabled={disabled} onClick={onTriggerClick}>
        <ViewListIcon className="mr-2 h-4 w-4" /> Variables
      </Button>
    </PopoverTrigger>
    <InputVariablesPopoverContent variables={variables} requestId={requestId} />
  </Popover>
);

export { InputVariablesPopover };
